import { QuoteType, TQuoteApiResponse } from '@models/quotes';

/**
 * A brokerage still in onboarding (lifecycleStatus 'Onboarding') is approved for quoting only — it can
 * be quoted but cannot bind new business/renewals until it is provisioned (→ 'Appointed'). Endorsements
 * run on an already-bound policy and are exempt, matching the server-side bind gate.
 *
 * Single source of truth for the bind block so the callout, the disabled Declaration, and the disabled
 * Bind button stay in lockstep — and `quoteType` is read from the quote itself (not the Quote store's
 * `isEndorsement`, which is briefly `undefined` during hydration).
 */
export const isBrokerageBindBlocked = (quote: TQuoteApiResponse): boolean =>
  quote.quoteType !== QuoteType.Endorsement && quote.brokerage?.lifecycleStatus === 'Onboarding';
